/**
 * Cheap booleans describing the live transcript buffers, published by the main
 * process (TranscriptManager) under the 'audio-note-transcript-presence'
 * GlobalState key. Lets renderers answer "is there a transcript?" without
 * subscribing to the full entry arrays — presence only changes on flips
 * (first text, clear), not on every appended entry.
 */
export interface TranscriptPresence {
  /** processed entries exist (length > 0) */
  hasProcessed: boolean
  /** any processed entry has non-empty text */
  processedHasText: boolean
  hasProvider: boolean
  providerHasText: boolean
  hasMerged: boolean
  mergedHasText: boolean
}

export const TRANSCRIPT_PRESENCE_KEY = 'audio-note-transcript-presence'

export const EMPTY_TRANSCRIPT_PRESENCE: TranscriptPresence = {
  hasProcessed: false,
  processedHasText: false,
  hasProvider: false,
  providerHasText: false,
  hasMerged: false,
  mergedHasText: false,
}
